<template>
  <div>
    <b-card :title="locals('menu.template')">
      <b-row> </b-row>
    </b-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseCheck from "@core/components/app-collapse/AppCollapseCheck.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import flatPickr from "vue-flatpickr-component";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import Cleave from "vue-cleave-component";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BFormCheckbox,
  BFormTextarea,
  BFormSelect,
  BPagination,
  BInputGroupPrepend,
  BFormFile,
} from "bootstrap-vue";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    AppCollapse,
    AppCollapseItem,
    AppCollapseCheck,
    BFormRadio,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BFormCheckbox,
    BFormSelect,
    vSelect,
    flatPickr,
    BFormTextarea,
    VueGoodTable,
    BPagination,
    BInputGroupPrepend,
    BButton,
    BFormFile,
    Cleave,
  },
  data() {
    return {
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      listServiceFreight: [
        {
          ficon: "",
          service: "",
          servicedesc: "",
          select: "",
          incoterm: "",
          dangerous_product_type: "",
          originPort: "",
          destPort: "",
          pickCountry: "",
          pickDistrict: "",
          pickSubDistrict: "",
          pickPostcode: "",
          pickImmigationCountry: "",
          pickImmigationPoint: "",
          deliCountry: "",
          deliDistrict: "",
          deliSubDistrict: "",
          deliPostcode: "",
          deliImmigationCountry: "",
          deliImmigationPoint: "",
          shipment_loading: "",
          require_doc_form: "",
          ifrequire: false,
        },
      ],
      testOptions: [
        {
          value: "TEST",
          label: "Data Test",
        },
        {
          value: "ETC",
          label: "อื่นๆ",
        },
      ],
      pageLength: 3,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          field: "action",
          width: "100px",
        },
        {
          label: "น้ำหนัก (kg)",
          field: "weight",
          width: "150px",
        },
        {
          label: "กว้าง (cm)",
          field: "breadth",
          width: "150px",
        },
        {
          label: "ยาว (cm)",
          field: "length ",
          width: "150px",
        },
        {
          label: "สูง (cm)",
          field: "hight",
          width: "150px",
        },
        {
          label: "จำนวน",
          field: "quantity",
          width: "150px",
        },
        {
          label: "หน่วยจำนวน",
          field: "unit",
          width: "150px",
        },
        {
          label: "ปริมาตร",
          field: "volumn",
          width: "150px",
        },
      ],
      rows: [
        {
          action: "",
          weight: "",
          email: "",
          startDate: "",
          salary: "",
        },
        {
          action: "",
          weight: "",
          email: "",
          startDate: "",
          salary: "",
        },
      ],
      searchTerm: "", 
    };
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {},
  methods: { 
    onAddServiceFreight() {
      var obj = {
        ficon: "",
        service: "",
        servicedesc: "",
        select: "",
        incoterm: "",
        dangerous_product_type: "",
        originPort: "",
        destPort: "",
        pickCountry: "",
        pickDistrict: "",
        pickSubDistrict: "",
        pickPostcode: "",
        pickImmigationCountry: "",
        pickImmigationPoint: "",
        deliCountry: "",
        deliDistrict: "",
        deliSubDistrict: "",
        deliPostcode: "",
        deliImmigationCountry: "",
        deliImmigationPoint: "",
        shipment_loading: "",
        require_doc_form: "",
        ifrequire: false,
      };
      this.listServiceFreight.push(obj);
    },
    removeServiceFreight(index) {
      this.listServiceFreight.splice(index, 1);
    }, 
    onAddSubFreight() {
      var obj = {
        weight: "",
        email: "",
        startDate: "",
        salary: "",
      };
      this.rows.push(obj);
    },
    removeSubFreight(index) {
      this.rows.splice(index, 1);
    }, 
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
